export default function Footer() {
  const CHANNELS = [
    {
      label: "WhatsApp",
      value: "+91 87224 40515",
      href: "https://wa.me/918722440515",
      external: true,
      testid: "footer-whatsapp",
    },
    {
      label: "Instagram",
      value: "@shenoyoncoffee",
      href: "https://www.instagram.com/shenoyoncoffee/",
      external: true,
      testid: "footer-instagram",
    },
    {
      label: "Email",
      value: "hello@anichyacoffee.com",
      href: "mailto:hello@anichyacoffee.com",
      external: false,
      testid: "footer-contact-email",
    },
  ];

  return (
    <footer className="bg-forest text-paper" data-testid="site-footer">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-10 md:gap-8">
          <div className="flex flex-col items-center" data-testid="footer-brand-block">
            <img
              src="/logo-ivory.png"
              alt="Anichya Coffee"
              className="h-20 w-20 md:h-[104px] md:w-[104px] object-contain"
              data-testid="footer-logo"
            />
            <p className="mt-5 font-serif italic text-xl md:text-2xl text-paper/90 whitespace-nowrap">
              Coffee, in its moment.
            </p>
          </div>

          <div className="hidden md:block w-px h-[136px] bg-sage/40" aria-hidden="true" />
          <div className="md:hidden h-px w-full bg-sage/25" aria-hidden="true" />

          <div
            id="contact"
            className="flex flex-col sm:flex-row items-center justify-center gap-8 sm:gap-12 lg:gap-20"
            data-testid="footer-contact-group"
          >
            {CHANNELS.map((c) => (
              <a
                key={c.label}
                href={c.href}
                {...(c.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                className="group text-center"
                data-testid={c.testid}
              >
                <span className="block text-[10px] uppercase tracking-[0.28em] text-sage">
                  {c.label}
                </span>
                <span className="link-underline inline-block mt-1.5 text-sm text-paper whitespace-nowrap">
                  {c.value}
                </span>
              </a>
            ))}
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-paper/15">
          <p className="text-xs text-sage" data-testid="footer-copyright">
            © 2026 Anichya Coffee
          </p>
        </div>
      </div>
    </footer>
  );
}
